module.exports = __webpack_public_path__ + "img/26f8.2d2f5b9.svg";